import { useState } from 'react'
import { useDSNotificationsContext } from '../../../../../DSNotificationsContext'
import { DisciplineFormItemProps, DisciplineItem } from './types'
import { LabeledValueType } from 'components/CIMSSelect/types'
import CIMSCollapse from 'components/CIMSCollapse'
import GroupFallback from '../../../../../components/GroupFallback'
import CIMSFormItem from 'components/CIMSFormItem'
import RecipientsSelect from 'components/CIMSSelect/common/RecipientsSelect'
import { Space } from 'antd'
import ApproverTags from '../../../../../components/ApproverTags'
import { useCIMSNotificationsPanelContext } from 'components/CIMSNotifications/components/CIMSNotificationsPanelContext'
import { DSNotificationEvent, alphabeticalSort } from '@cims-online/shared'

const DisciplineFormItem: React.VFC<DisciplineFormItemProps> = ({
  onChange,
  value,
}) => {
  const { event } = useCIMSNotificationsPanelContext()
  const { data } = useDSNotificationsContext()
  const [values, setValues] = useState<Map<string, DisciplineItem>>(
    (value ?? []).reduce(
      (map, v) => map.set(v.dsDisciplineId, v),
      new Map<string, DisciplineItem>()
    )
  )
  const change = (id: string, recipients: LabeledValueType[]) =>
    setValues((prev) => {
      const map = new Map(prev)
      map.set(id, { dsDisciplineId: id, recipients })
      onChange?.([...map.values()])
      return map
    })

  return (
    <CIMSCollapse
      noPanelsContent={<GroupFallback />}
      panels={(data?.dsDisciplines ?? [])
        .sort(alphabeticalSort('name'))
        .map(({ id, name, description }) => {
          return {
            key: id,
            header: {
              type: 'described',
              name,
              description,
            },
            children: (
              <Space
                size="large"
                direction="vertical"
                style={{ width: '100%' }}
              >
                {event === DSNotificationEvent.RoutedToDisciplineAction && (
                  <ApproverTags discipline={{ id, name }} />
                )}
                <CIMSFormItem label="Recipients">
                  <RecipientsSelect
                    value={values.get(id)?.recipients ?? []}
                    onChange={(recipients) =>
                      change(id, recipients as LabeledValueType[])
                    }
                  />
                </CIMSFormItem>
              </Space>
            ),
          }
        })}
    />
  )
}

export default DisciplineFormItem
